import styled, { css } from 'styled-components';
import { Column, Row } from '@simplywallst/ui-core';
import { media } from '@simplywallst/ui-core';

export const SWSLogo = styled('div')`
  ${media.smDown`
    text-align: center;
  `}
  svg {
    width: 190px;
    margin-bottom: ${({ theme }) => theme.x3spacePx}px;
    display: inline-block;
  }
`;

export const LeftColumn = styled(Column)`
  ${media.smDown`
    text-align: center;
  `}
`;

export const Address = styled('address')`
  opacity: 0.5;
  font-style: normal;
  margin-bottom: ${({ theme }) => theme.x2spacePx}px;
`;

export const AppBadge = styled('a')`
  display: inline-block;
  margin-right: ${({ theme }) => theme.x1spacePx}px;
  > img {
    max-width: 135px;
  }
  margin-bottom: ${({ theme }) => theme.x3spacePx}px;
`;

export const LogoContainer = styled(Row)`
  margin-bottom: ${({ theme }) => theme.x3spacePx}px;
`;

export const StyledA = styled.a`
  padding-right: ${(props) => props.theme.x2spacePx}px;
`;

const Links = css`
  > a {
    color: ${({ theme }) => theme.color.white};
    text-decoration: none;
    margin-bottom: ${({ theme }) => theme.x3spacePx}px;
    margin-right: ${({ theme }) => theme.x3spacePx}px;
    white-space: nowrap;
    display: inline-block;
    &:hover {
      text-decoration: underline;
    }
    ${media.smDown`
      margin-right: ${({ theme }) => theme.x3spacePx / 2}px;
      margin-left: ${({ theme }) => theme.x3spacePx / 2}px;
      margin-bottom: ${({ theme }) => theme.x2spacePx}px;
    `}
  }
  > a:last-child {
    margin-right: 0;
  }
  ${media.smDown`
    text-align: center;
  `}
`;

export const PrimaryLinks = styled('div')`
  ${Links}
`;

export const SecondaryLinks = styled('div')`
  ${Links}
  opacity: 0.5;
  ${media.smDown`
    margin-top: ${({ theme }) => theme.x2spacePx}px;
  `}
`;

export const MarketPageLinks = styled(Row)`
  margin-top: 16px;
  margin-bottom: 24px;
  > span {
    ${({ theme }) => theme.typography.xSmall}
    color: ${({ theme }) => theme.color.whiteRGBA(0.5)};
    margin-right: ${({ theme }) => theme.x3spacePx}px;
  }

  a {
    margin-bottom: 0;
  }

  ${media.lgOnly`
    > span {
      margin-right: 16px;
    }
    a {
      margin-right: 16px;
    }
  `}

  ${media.smDown`
    margin-top: 0;
    flex-direction: column;
    align-items: center;
    > span {
      margin-bottom: ${({ theme }) => theme.x1spacePx}px;
    }
  `}
`;

export const Disclaimer = styled('div')`
  ${({ theme }) => theme.typography.xSmall}
  opacity: 0.5;
  ${media.smDown`
    margin-top: ${({ theme }) => theme.x2spacePx}px;
  `}
`;

const centerCSS = css`
  ${SWSLogo},
  ${LeftColumn},
  ${PrimaryLinks},
  ${SecondaryLinks} {
    text-align: center;
  }
  ${PrimaryLinks},
  ${SecondaryLinks} {
    > a {
      margin-right: ${({ theme }) => theme.x3spacePx / 2}px;
      margin-left: ${({ theme }) => theme.x3spacePx / 2}px;
    }
  }
  ${MarketPageLinks} {
    margin-top: 0;
    flex-direction: column;
    align-items: center;
    > span {
      margin-bottom: ${({ theme }) => theme.x1spacePx}px;
    }
  }
`;

export const Wrapper = styled('footer')<{ center?: boolean }>`
  ${({ theme }) => theme.typography.xSmall}
  ${media.mdDown`
    padding-left: ${({ theme }) => theme.x2spacePx}px;
    padding-right: ${({ theme }) => theme.x2spacePx}px;
  `}
  padding-top: ${({ theme }) => theme.x3spacePx}px;
  padding-bottom: ${({ theme }) => theme.x5spacePx}px;
  color: ${({ theme }) => theme.color.white};
  ${({ center }) => center && centerCSS}
`;
